import { useEmailAlreadyTaken } from "@gik/api/users/auth";
import {
	ExternalLoginProvider,
	LoginProvider,
} from "@gik/auth/utils/LoginProvider";

export default function useLoginProvider(email: string): LoginProvider {
	const { data: emailTakenStatus } = useEmailAlreadyTaken(email);
	if (!emailTakenStatus) return;

	const provider = Object.values(ExternalLoginProvider).find(
		(value) => !!emailTakenStatus?.[value],
	);
	if (!provider) return LoginProvider.EMAIL;
	return provider;
}
